import { useEffect, useState } from "react";
import { Play, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const AudioCell = ({ id, audio, testId }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  if (!audio) return <span className="text-xs text-slate-400">No audio</span>;
  if (url) return <audio controls autoPlay src={url} className="h-9 w-56" data-testid={`${testId}-player`} />;

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/feedback/${id}/audio`, { responseType: "blob" });
      setUrl(URL.createObjectURL(r.data));
    } catch (e) {
      toast.error("Could not load audio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={load}
      className="inline-flex items-center gap-2 rounded-full bg-emerald-900 px-3 py-1.5 text-xs font-semibold text-amber-50 hover:bg-emerald-800 transition-colors"
    >
      {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Play className="h-3.5 w-3.5 fill-current" />}
      Play
    </button>
  );
};
